<template>
  <div>
    <PlanDetail v-if="step == 1" @nexStep="nexStep" />
    <Payment
      v-else-if="step == 2"
      @nexStep="nexStep"
      @previousStep="previousStep"
    />
    <Success v-else />
  </div>
</template>

<script>
import PlanDetail from "./components/plan-detail/plan_detail";
import Payment from "./components/plan-detail/payment";
import Success from "./components/plan-detail/success";

export default {
  components: {
    PlanDetail,
    Payment,
    Success,
  },
  data() {
    return {
      step: 1,
    };
  },
  methods: {
    nexStep() {
      this.step++;
    },
    previousStep() {
      this.step--;
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// plan_detail.vue?27f2f7f2